"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pool = void 0;
const primitives_1 = __importDefault(require("@acala-network/type-definitions/primitives"));
const operators_1 = require("rxjs/operators");
const util_1 = require("@polkadot/api-derive/util");
const TOKEN_SORT = primitives_1.default.types.TokenSymbol._enum;
function sortTokens(token1, token2) {
    const result = [token1, token2];
    return result.sort((a, b) => TOKEN_SORT[a.asToken.toString()] - TOKEN_SORT[b.asToken.toString()]);
}
/**
 * @name pool
 * @description get liquidity pool of the target currency id
 * @param {CurrencyId} currency target currency id
 */
function pool(instanceId, api) {
    return (0, util_1.memo)(instanceId, (token1, token2) => {
        const params = sortTokens(token1, token2);
        return api.query.dex.liquidityPool(params).pipe((0, operators_1.map)((result) => {
            const [token1Amount, token2Amount] = result;
            if (token1.eq(params[0]) && token2.eq(params[1])) {
                return [token1Amount, token2Amount];
            }
            return [token2Amount, token1Amount];
        }));
    });
}
exports.pool = pool;
